module.exports = __webpack_public_path__ + "img/checkbox-square-activation.cc656b3b.svg";